import React, { useEffect } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../../utils/language';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFile, faCaretRight, faLink } from "@fortawesome/free-solid-svg-icons"
import IconButton from '@material-ui/core/IconButton';
import * as keyMenu from '../../../scripts/KeyMenu';
import background_documents from "../../../images/document.png";

const useStyles = makeStyles((theme) => ({
    divRootDocument: {
        color: '#ffffff',
        height: '37px',
        //borderBottom: '1px solid rgb(255 255 255 / 40%)',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
    },
    divContent: {
        margin: '5px 5px',
        padding: '4px 0px',
        textAlign: 'left',
        color: '#ffffff',
        '& > div > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        '& > div > span': {
            display: 'table'
        }
    },
    title: {

    },
    divFooter: {
        textAlign: 'center',
        '& > svg': {
            margin: '0px 10px 0px 0px'
        }
    },
    linkGoIcon: {
        fontSize: '16px !important',
        padding: 'unset'
    },
    divBodyDocument: {
        height: '205px',
        overflow: 'auto',
        borderRadius: '8px',
        marginTop: '4px'
    },
    spanNoContent: {
        textAlign: 'center',
        display: 'table',
        width: '100%',
        marginTop: '10px',
    },
    documentImg: {
        width: '25px',
    },
    documentTitle: {
        verticalAlign: 'middle',
        marginLeft: '10px',
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    }
}));

function Document(props) {
    const classes = useStyles();

    const [data, setData] = React.useState(null);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined && props.data.length > 0) {
            loadDocument();
        }
    }, [props.data]);

    const loadDocument = () => {
        setData(props.data);
    }

    const handleSelectedPage = () => {
        props.handleSelectedPage(keyMenu.MENU_DOCUMENTS);
    }

    return (
        <>
            <div className={classes.divRootDocument}>
                <img className={classes.documentImg} src={background_documents} />
                <span className={classes.documentTitle}>Documents</span>
            </div>
            <div className={classes.divBodyDocument}>
                {data && data.map((obj, index) =>
                    <div className={classes.divContent} key={index}>
                        <div>
                            <FontAwesomeIcon icon={faCaretRight} className="fa-w-16" />
                            <span className={classes.title}>{obj.fileName} - {IsEnglish() ? obj.descriptionE : obj.descriptionF}</span>
                        </div>
                    </div>
                )}
                {(data === null) && <span className={classes.spanNoContent}>{i18next.t("home:homeContent.noDocument")}</span>}
            </div>

            <div className={classes.divFooter}>
                <IconButton className={classes.linkGoIcon} edge="start" color="inherit" onClick={handleSelectedPage} aria-label="close">
                    <FontAwesomeIcon icon={faLink} className="fa-w-16" />
                    <span className={classes.linkGo}>{i18next.t('home:homeContent.goLink')}</span>
                </IconButton>
            </div>
        </>
    );
}
export default withNamespaces(['HomeContent'], { wait: true })(Document);